import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { EVENT_SORT_DRAWER_OPEN, SortDrawer } from "@app/components/SortDrawer";
import { FilterChip } from "@app/components/SortDrawer/FilterChip";
import { Accordion } from "@app/components/Drawer/Accordion";

/**
 * Mount drawers for testing purposes.
 */

const test1 = document.querySelector(".test-filter-drawer");
if (test1) {
  const FilterSelected = (
    <>
      <FilterChip label="Shirts" />
      <FilterChip label="Essentials" />
      <FilterChip label="Girls" />
      <FilterChip label="14" />
    </>
  );

  const Filters = () => {
    const [sortValue, setSortValue] = useState("default");
    const [categoryValue, setCategoryValue] = useState(["1"]);

    const handleChangeSort = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSortValue(e.target.value);
    };

    const handleCategorySort = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        setCategoryValue([...categoryValue, e.target.value]);
      } else {
        setCategoryValue(categoryValue.filter((value) => value !== e.target.value));
      }
    };

    return (
      <>
        <Accordion
          items={[
            {
              title: "Sort by",
              isOpen: true,
              content: (
                <>
                  <label className="radio-item" for="default">
                    <input
                      className="radio-input"
                      type="radio"
                      id="default"
                      name="sort"
                      value="default"
                      checked={sortValue === "default"}
                      onChange={handleChangeSort}
                    />
                    <div>Default</div>
                  </label>
                  <label className="radio-item" for="best-sellers">
                    <input
                      className="radio-input"
                      type="radio"
                      id="best-sellers"
                      name="sort"
                      value="best-sellers"
                      checked={sortValue === "best-sellers"}
                      onChange={handleChangeSort}
                    />
                    <div>Best Sellers</div>
                  </label>
                </>
              ),
            },
            {
              title: "Category",
              content: (
                <>
                  <label className="checkbox-item" for="1">
                    <input
                      className="checkbox-input"
                      type="checkbox"
                      id="1"
                      name="category"
                      value="1"
                      checked={categoryValue.includes("1")}
                      onChange={handleCategorySort}
                    />
                    <div className="checkbox-label">
                      <div className="checkbox-label-main">Checkbox Label</div>
                      <div className="checkbox-label-sub">(12)</div>
                    </div>
                  </label>
                  <label className="checkbox-item" for="2">
                    <input
                      className="checkbox-input"
                      type="checkbox"
                      id="2"
                      name="category"
                      value="2"
                      checked={categoryValue.includes("2")}
                      onChange={handleCategorySort}
                    />
                    <div className="checkbox-label">
                      <div className="checkbox-label-main">Checkbox Label</div>
                      <div className="checkbox-label-sub">(12)</div>
                    </div>
                  </label>
                  <label className="checkbox-item" for="3">
                    <input
                      className="checkbox-input"
                      type="checkbox"
                      id="3"
                      name="category"
                      value="3"
                      checked={categoryValue.includes("3")}
                      onChange={handleCategorySort}
                    />
                    <div className="checkbox-label">
                      <div className="checkbox-label-main">Checkbox Label</div>
                      <div className="checkbox-label-sub">(12)</div>
                    </div>
                  </label>
                </>
              ),
            },
          ]}
        />
      </>
    );
  };

  const root = ReactDOM.createRoot(test1);
  root.render(<SortDrawer FilterSelected={FilterSelected} Filters={<Filters />} />);

  document.querySelector(".test-filter-button")?.addEventListener("click", () => {
    document.dispatchEvent(new CustomEvent(EVENT_SORT_DRAWER_OPEN));
  });
}
